import { Component, OnInit, OnDestroy } from '@angular/core';
import { ReportsHelpbuttonService } from '../../../services/helpbutton-services/reports-helpbutton-service/reports-helpbutton.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-helpbutton-reports-dashboard',
  templateUrl: './helpbutton-reports-dashboard.component.html',
  styleUrls: ['./helpbutton-reports-dashboard.component.scss']
})
export class HelpbuttonReportsDashboardComponent implements OnInit, OnDestroy {

  assistances;
  assistanceNumber: number;
  assistancePhysicalNumber: number;
  assistanceVideoNumber: number;
  assistanceVoiceNumber: number;
  assistanceAverageRespondTimeMillis: number;
  assistanceAverageTimeMillis: number;
  assistancePhysicalAverageTimeMillis: number;
  assistanceQueryAverageTimeMillis: number;
  assistanceVideoAverageTimeMillis: number;
  badCommentsNumber: number;
  neutralCommentsNumber: number;
  goodCommentsNumber: number;
  totalAbandoned: number;
  totalAbandonedPhysical: number;
  totalAbandonedVideo: number;
  totalAbandonedVoice: number;
  totalRequestAbandoned: number;
  totalRequestAbandonedPhysical: number;
  totalRequestAbandonedVideo: number;
  totalRequestAbandonedVoice: number;
  totalExperience: number;
  totalExperiencePhysical: number;
  totalExperienceVideo: number;
  totalExperienceVoice: number;
  totalQuery: number;
  totalQueryPhysical: number;
  totalQueryVideo: number;
  totalQueryVoice: number;
  acceptedRequest: number;
  unattendedRequest: number;
  unattendedRequestPercentage: number;
  uncommentedVideoPercentage: number;
  uncommentedVoicePercentage: number;
  uncommentedVideo: number;
  uncommentedVoice: number;
  getDailyReportsSubscription: Subscription;
  refreshAssistancesListSubscription: Subscription;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private reportsService: ReportsHelpbuttonService,
              private userStorageService: UserStorageService,
              private snackbarService: SnackBarService,
              private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getDailyReports();
    this.refreshAssistancesListSubscription = this.reportsService.refreshAssistancesListListen().subscribe(
      (res) => {
        if (res) {
          this.assistances = res['data']['assistanceList'];
          this.assistanceNumber = res['data']['assistanceNumber'];
          this.assistancePhysicalNumber = res['data']['assistancePhysicalNumber'];
          this.assistanceVideoNumber = res['data']['assistanceVideoNumber'];
          this.assistanceVoiceNumber = res['data']['assistanceVoiceNumber'];
          this.assistanceAverageRespondTimeMillis = res['data']['assistanceAverageRespondTimeMillis'];
          this.assistanceAverageTimeMillis = res['data']['assistanceAverageTimeMillis'];
          this.assistancePhysicalAverageTimeMillis = res['data']['assistancePhysicalAverageTimeMillis'];
          this.assistanceQueryAverageTimeMillis = res['data']['assistanceQueryAverageTimeMillis'];
          this.assistanceVideoAverageTimeMillis = res['data']['assistanceVideoAverageTimeMillis'];
          this.badCommentsNumber = res['data']['badCommentsNumber'];
          this.neutralCommentsNumber = res['data']['neutralCommentsNumber'];
          this.goodCommentsNumber = res['data']['goodCommentsNumber'];
          this.totalAbandoned = res['data']['totalAbandoned'];
          this.totalAbandonedPhysical = res['data']['totalAbandonedPhysical'];
          this.totalAbandonedVideo = res['data']['totalAbandonedVideo'];
          this.totalAbandonedVoice = res['data']['totalAbandonedVoice'];
          this.totalRequestAbandoned = res['data']['totalRequestAbandoned'];
          this.totalRequestAbandonedPhysical = res['data']['totalRequestAbandonedPhysical'];
          this.totalRequestAbandonedVideo = res['data']['totalRequestAbandonedVideo'];
          this.totalRequestAbandonedVoice = res['data']['totalRequestAbandonedVoice'];
          this.totalExperience = res['data']['totalExperience'];
          this.totalExperiencePhysical = res['data']['totalExperiencePhysical'];
          this.totalExperienceVideo = res['data']['totalExperienceVideo'];
          this.totalExperienceVoice = res['data']['totalExperienceVoice'];
          this.totalQuery = res['data']['totalQuery'];
          this.totalQueryPhysical = res['data']['totalQueryPhysical'];
          this.totalQueryVideo = res['data']['totalQueryVideo'];
          this.totalQueryVoice = res['data']['totalQueryVoice'];
          this.acceptedRequest = res['data']['acceptedRequest'];
          this.unattendedRequest = res['data']['unattendedRequest'];
          this.unattendedRequestPercentage = res['data']['unattendedRequestPercentage'];
          this.uncommentedVideoPercentage = res['data']['uncommentedVideoPercentage'];
          this.uncommentedVoicePercentage = res['data']['uncommentedVoicePercentage'];
          this.uncommentedVideo = res['data']['uncommentedVideo'];
          this.uncommentedVoice = res['data']['uncommentedVoice'];
        }
      },
      (error) => { }
    );
  }

  private getDailyReports() {
    const todayFrom = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0).getTime();
    const todayTo = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1, 0, 0, 0).getTime();
    this.getDailyReportsSubscription = this.reportsService.filterAssistanceList(this.userStorageService.getCenterList('InternalId'), todayFrom, todayTo, new Array<any>(), new Array<any>()).subscribe(
      (res) => {
        if (res) {
          const assistances = new Array<Object>();
          res['data']['assistanceList'].forEach(
            (item) => {
              // No modelo assistance aqui porque estan metiendo un centerDto que no existe en los modelos. Trabajo directamente con json
              const assistance = new Object();
              Object.assign(assistance, item);
              assistances.push(assistance);
            }
          );
          this.assistances = assistances;
          this.assistanceNumber = res['data']['assistanceNumber'];
          this.assistancePhysicalNumber = res['data']['assistancePhysicalNumber'];
          this.assistanceVideoNumber = res['data']['assistanceVideoNumber'];
          this.assistanceVoiceNumber = res['data']['assistanceVoiceNumber'];
          this.assistanceAverageRespondTimeMillis = res['data']['assistanceAverageRespondTimeMillis'];
          this.assistanceAverageTimeMillis = res['data']['assistanceAverageTimeMillis'];
          this.assistancePhysicalAverageTimeMillis = res['data']['assistancePhysicalAverageTimeMillis'];
          this.assistanceQueryAverageTimeMillis = res['data']['assistanceQueryAverageTimeMillis'];
          this.assistanceVideoAverageTimeMillis = res['data']['assistanceVideoAverageTimeMillis'];
          this.badCommentsNumber = res['data']['badCommentsNumber'];
          this.neutralCommentsNumber = res['data']['neutralCommentsNumber'];
          this.goodCommentsNumber = res['data']['goodCommentsNumber'];
          this.totalAbandoned = res['data']['totalAbandoned'];
          this.totalAbandonedPhysical = res['data']['totalAbandonedPhysical'];
          this.totalAbandonedVideo = res['data']['totalAbandonedVideo'];
          this.totalAbandonedVoice = res['data']['totalAbandonedVoice'];
          this.totalRequestAbandoned = res['data']['totalRequestAbandoned'];
          this.totalRequestAbandonedPhysical = res['data']['totalRequestAbandonedPhysical'];
          this.totalRequestAbandonedVideo = res['data']['totalRequestAbandonedVideo'];
          this.totalRequestAbandonedVoice = res['data']['totalRequestAbandonedVoice'];
          this.totalExperience = res['data']['totalExperience'];
          this.totalExperiencePhysical = res['data']['totalExperiencePhysical'];
          this.totalExperienceVideo = res['data']['totalExperienceVideo'];
          this.totalExperienceVoice = res['data']['totalExperienceVoice'];
          this.totalQuery = res['data']['totalQuery'];
          this.totalQueryPhysical = res['data']['totalQueryPhysical'];
          this.totalQueryVideo = res['data']['totalQueryVideo'];
          this.totalQueryVoice = res['data']['totalQueryVoice'];
          this.acceptedRequest = res['data']['acceptedRequest'];
          this.unattendedRequest = res['data']['unattendedRequest'];
          this.unattendedRequestPercentage = res['data']['unattendedRequestPercentage'];
          this.uncommentedVideoPercentage = res['data']['uncommentedVideoPercentage'];
          this.uncommentedVoicePercentage = res['data']['uncommentedVoicePercentage'];
          this.uncommentedVideo = res['data']['uncommentedVideo'];
          this.uncommentedVoice = res['data']['uncommentedVoice'];
        }
      },
      (error) => {
        this.router.navigate(['../../helpbutton'], {relativeTo: this.activatedRoute});
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-file', 'helpbutton-page.assistance report', '/helpbutton', [new BRoute('helpbutton-page.helpbutton', '/helpbutton'), new BRoute('helpbutton-page.assistance report')]));
  }

  ngOnDestroy() {
    if (this.getDailyReportsSubscription) { this.getDailyReportsSubscription.unsubscribe(); }
    if (this.refreshAssistancesListSubscription) { this.refreshAssistancesListSubscription.unsubscribe(); }
  }

}
